import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider as StoreProvider } from 'react-redux';
import { SnackbarProvider } from 'notistack';

import App from './App';
import reportWebVitals from './reportWebVitals';
import PreferencesProvider from './providers/PreferencesProvider';
import store from './store';

import './index.css';
import ScrollToTopWrapper from './components/global/ScrollToTopWrapper';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <PreferencesProvider>
    <StoreProvider store={store}>
      <BrowserRouter>
        <SnackbarProvider>
          <ScrollToTopWrapper>
            <App />
          </ScrollToTopWrapper>
        </SnackbarProvider>
      </BrowserRouter>
    </StoreProvider>
  </PreferencesProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
